import { gsap } from "gsap"
import { Flip } from "gsap/Flip"
import { refreshAllControllers } from "@/scripts/common/api/scrolltrigger.services"
import { LazyLoad } from '@/scripts/lazyload/Lazyload'
gsap.registerPlugin(Flip)

const CLASS_FILTER_PRE = 'ui-filter'
export const UIFilter = (function () {
    class Filter {
        constructor(container) {
            this.$filterContainer = container
            this.$filterOptions = this.$filterContainer.querySelector(`.${CLASS_FILTER_PRE}__options`)
            this.$filterPanel = this.$filterContainer.querySelector(`.${CLASS_FILTER_PRE}__panel`)
            this.$filterPanelCols = this.$filterContainer.querySelectorAll(`.${CLASS_FILTER_PRE}-grid__panel-col`)
            this.$filterItems = gsap.utils.toArray(this.$filterPanel.querySelectorAll(`.${CLASS_FILTER_PRE}__panel-item`))
            this.$filterAllBtn = this.$filterContainer.querySelector(`.${CLASS_FILTER_PRE}__all-btn`)
            this.$filterCarousel = this.$filterContainer.querySelector(`.card-carousel__list`)
            this.noFlipAnimateFeature = this.$filterContainer.dataset.noFlipAnimate || false
            this.flipItemsState = null
            this.flipPanelState = null
            this.filterValues = []
            this.events = []
            this.carouselList = !!this.$filterContainer.dataset.filterCarousel

            this.options = {
                noItemMessage: 'We are sorry. No result were found for the selected filters(s)'
            }
        }

        init() {
            this.eventBuilder()
            this.updateValue()
            this.updateUI()
            this.addListeners()
        }

        updateValue() {
            this.filterValues = []
            const $checkedInputs = this.$filterOptions.querySelectorAll('input:checked')
            const $dropdowns = this.$filterOptions.querySelectorAll('.dropdown')
            $checkedInputs.forEach($inp => this.filterValues.push($inp.value))
            $dropdowns.forEach($dd => $dd.value ? this.filterValues.push($dd.value) : this.filterValues.push('all'))
        }

        updateUI() {
            if(!this.noFlipAnimateFeature) this.getFlipStates()
            this.toggleClasses()
            this.filteringItems()
            this.noItemsUpdate()
            if(!this.noFlipAnimateFeature) this.flipAnimate()

        }

        updateClassPanelCols() {
            let totalItemsArr = []
            this.$filterPanelCols.forEach(($col) => {
                $col.classList.remove(`${CLASS_FILTER_PRE}-grid__panel-col--larger`)
                const $items = $col.querySelectorAll(`.${CLASS_FILTER_PRE}__panel-item:not([style*="display: none"]):not(.${CLASS_FILTER_PRE}__panel-item--hidden)`)
                totalItemsArr.push($items.length)
            })
            this.$filterPanelCols[totalItemsArr.indexOf(Math.max(...totalItemsArr))].classList.add(`${CLASS_FILTER_PRE}-grid__panel-col--larger`)
        }

        toggleClasses() {
            const $filterOptionItems = this.$filterOptions.querySelectorAll(`.${CLASS_FILTER_PRE}__options-item`)

            $filterOptionItems.forEach($opt => {
                $opt.classList.remove(`${CLASS_FILTER_PRE}__options-item--active`)
                const $input = $opt.querySelector('input')
                if ($input)
                    if (this.filterValues.findIndex(val => val === $input.value) !== -1) $opt.classList.add(`${CLASS_FILTER_PRE}__options-item--active`)
            })
        }

        filteringItems() {

            this.$filterItems.forEach($item => {
                // this.filterValues.findIndex(val => {
                //     $item.dataset.group.match(val)
                // })
                if(this.filterValues.findIndex(val => this.filterMatch($item.dataset.group, val) || val === 'all') === -1) {
                    $item.style.display = 'none'
                    $item.classList.add(`${CLASS_FILTER_PRE}__panel-item--hidden`)
                    return
                }
                $item.style.display = 'flex'
                $item.classList.remove(`${CLASS_FILTER_PRE}__panel-item--hidden`)
            })

            
        }

        filterMatch(group, val) {
            const groups = group.split(',').map(item => item.trim())
            //return groups.indexOf(val) !== -1
            return groups.includes(val)
        }

        // FLIP
        getFlipStates() {
            this.flipItemState = Flip.getState(this.$filterItems)
            this.flipPanelState = Flip.getState(this.$filterPanel)
        }

        flipAnimate() {
            const tl = gsap.timeline({
                onStart: () => this.$filterContainer.dispatchEvent(this.events['UIFilterStart']),
                onComplete: () => {
                    refreshAllControllers()
                    this.$filterContainer.dispatchEvent(this.events['UIFilterUpdated'])
                }
            })
            tl.add(Flip.from(this.flipItemState, {
                duration: 0.4,
                scale: false,
                ease: "power2.inOut",
                toggleClass: `${CLASS_FILTER_PRE}__panel-item--is-flipping`,
                stagger: 0,
                absolute: false,
                onEnter: elements => gsap.fromTo(elements, { opacity: 0, scale: 1 }, { opacity: 1, scale: 1, duration: 0.4 }),
                onLeave: elements => gsap.fromTo(elements, { opacity: 1, scale: 1 }, { opacity: 0, scale: 0, duration: 0.4 })
            }), 0)
                .add(Flip.from(this.flipPanelState, {
                    duration: 0.4,
                    scale: false,
                    ease: "power2.inOut",
                    toggleClass: `${CLASS_FILTER_PRE}__panel--is-flipping`,
                    absolute: false,
                    nested: true
                }), 0)

        }

        // On update callbacks
        onFilterUpdate() {
            if (this.$filterPanelCols.length) this.updateClassPanelCols()
        }

        // Event creator

        eventBuilder() {
            this.events['UIFilterStart'] = new CustomEvent('UIFilterStart', {
                bubbles: true
            })

            this.events['UIFilterUpdated'] = new CustomEvent('UIFilterUpdated', {
                bubbles: true
            })
        }

        // Empty check
        noItemsUpdate() {
            const selectedItems = this.$filterItems.find($item => !$item.classList.contains(`${CLASS_FILTER_PRE}__panel-item--hidden`)) !== undefined
            const infoDiv = this.$filterPanel.querySelector(`.${CLASS_FILTER_PRE}__panel-info`)
            if(infoDiv) infoDiv.remove()
            
            if(!selectedItems) {
                const infoDiv = document.createElement('div')
                infoDiv.classList.add(`${CLASS_FILTER_PRE}__panel-info`)
                infoDiv.innerHTML = `<p class="">${this.options.noItemMessage}</p>`
                this.$filterPanel.prepend(infoDiv)
                return
            }
        }

        // Handlers
        inputHandler() {
            this.updateValue()
            this.updateUI()
        }

        defaultDropdowns(e) {
            e.preventDefault()
            const $dropdowns = this.$filterOptions.querySelectorAll('.dropdown')
            $dropdowns.forEach($dd => {
                $dd.setValue('')
            })
        }

        addListeners() {
            const $inputs = this.$filterOptions.querySelectorAll('input')
            const $dropdowns = this.$filterOptions.querySelectorAll('.dropdown')

            $inputs.forEach($inp => $inp.addEventListener('change', () => this.inputHandler()))
            $dropdowns.forEach($dd => $dd.addEventListener('select', () => this.inputHandler()))

            this.$filterContainer.addEventListener('UIFilterUpdated', () => this.onFilterUpdate())

            this.$filterAllBtn?.addEventListener('click', (e) => this.defaultDropdowns(e))
        }
    }

    class FilterSelection extends Filter {
        constructor(container) {
            super(container)

            this.filterValues = this.$filterContainer.dataset.filters ?
                this.$filterContainer.dataset.filters.split(',').map(f => {
                    return {
                        name: f.trim(),
                        value: []
                    }
                }) : []
        }

        init() {
            this.eventBuilder()
            this.updateValue()
            this.updateUI()
            this.addListeners()
        }

        updateUI() {
            if(this.carouselList) {
                this.filteringCarousel()
                return
            }
            this.getFlipStates()
            this.filteringItems()
            this.noItemsUpdate()
            this.flipAnimate()
        }

        // Values and filtering
        updateValue() {
            const $dropdowns = gsap.utils.toArray(this.$filterOptions.querySelectorAll('.dropdown'))
            this.filterValues.forEach(v => {
                const $dd = $dropdowns[$dropdowns.findIndex($dd => $dd.classList.contains(`dropdown--filter-${v.name}`))]
                v.value = []
                v.value.push($dd.value || 'all')
            })
        }

        filteringCarousel() {
            const filterSelector = `${this.filterValues.map((val) => `[data-${val.name}${val.value[0] === 'all' ? '' : `="${val.value[0]}"`}]`).join('')}`
            
            $(this.$filterCarousel).slick('slickUnfilter')
            $(this.$filterCarousel).slick('slickFilter',filterSelector)

            const $lazyload = this.$filterCarousel.querySelectorAll('.lazyload')
            $lazyload.forEach($bg => {
                if(!$bg.classList.contains('bg-img--loaded'))  new LazyLoad($bg)
            })
        }

        filteringItems() {
           
            this.$filterItems.forEach($item => {
                let activeCond = []
                this.filterValues.forEach(fv => {
                    const filterName = fv.name
                    const filterValue = fv.value
                    
                    activeCond.push(filterValue.findIndex(val => this.filterMatch($item.dataset[filterName], val) || val === 'all') === -1 ? false : true)
                })

                if(!activeCond.every(cond => cond)) {
                    $item.style.display = 'none'
                    $item.classList.add(`${CLASS_FILTER_PRE}__panel-item--hidden`)
                    return
                }

                $item.style.display = 'flex'
                $item.classList.remove(`${CLASS_FILTER_PRE}__panel-item--hidden`)
                
            })
        }

        // Callbacks
        inputHandler() {
            this.updateValue()
            this.updateUI()
        }
    }

    return {
        Filter,
        FilterSelection
    }
})()